// extracted by mini-css-extract-plugin
export default {"root":"IconLock_root__+Liqf"};